<template>
  <div>
    <input class="e-field e-input e-defaultcell e-control e-textbox e-lib color-input" style="width:50px" v-model="selectedColor" :id="`grid_${rand}_${data.column.index}${data.column.field}`" :name="data.column.field" :data-id="data.id" :eMappinguid="`grid_${rand}_${data.column.index}${data.column.field}`" role="textbox">
    <v-menu
      v-model="dialogColorPicker"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
      >
    <template v-slot:activator="{ on, attrs }">
      <v-chip label class="color-chip" :color="selectedColor" dark small v-bind="attrs" v-on="on">
      </v-chip>
    </template>
    <v-card>
     
        <v-color-picker class="ma-2" v-model="selectedColor" elevation="2" hide-inputs hide-mode-switch>
      </v-color-picker>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="pageHeader" text @click="selectColor()" small> Ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
  </div>
  
</template>
<script>
export default {
  name: "gridColorSelector",
};
</script>
<style scoped>
.color-input{
  border: none;
  border-color: initial;
  height: 0px !important;
  width: 0px !important;
}
.color-chip{
  width: 100px !important;
  border: 1px solid rgba(0, 0, 0, 0.5) !important;
}
</style>